<div class="questionnaire-container">
  @if (isLoadingQuestionnaire) {
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  } @else if (errorMessage) {
    <div class="alert alert-danger">{{ errorMessage }}</div>
  } @else {
    <div class="table-controls">
      <div
        ngbDropdown
        class="d-inline-block"
        [autoClose]="'outside'"
        (openChange)="onDropdownClose($event)"
      >
        <div
          class="filter-button"
          [class.active]="hasAnyFiltersApplied()"
          ngbDropdownToggle
        >
          <i class="bi bi-filter"></i>
          Filter
        </div>

        <div ngbDropdownMenu>
          <div class="filter-dropdown-menu">
            <div class="filter-menu-header">
              <h5 class="dropdown-title">Filters</h5>

              <button
                class="btn btn-outline-primary btn-sm"
                (click)="clearFilters()"
              >
                Clear Filters
              </button>
            </div>

            <input
              inputmode="search"
              role="searchbox"
              type="search"
              name="filter-search"
              class="form-control filter-search"
              placeholder="Search filters..."
              [(ngModel)]="filterSearch"
            />

            <div
              class="filter-category"
              *ngFor="let filter of getFilteredFilters()"
              [class.active]="
                activeSubFilter === filter.key ||
                hasSelectedFilterOption(filter.key)
              "
              (click)="setActiveSubFilter(filter.key, filterItem)"
              #filterItem
            >
              {{ filter.label }}
              <i class="bi bi-chevron-right float-end"></i>
            </div>
          </div>

          <div
            class="sub-filter-dropdown"
            *ngIf="activeSubFilter"
            [style.top.px]="subFilterTopOffset"
          >
            <h6>{{ getFilterLabel(activeSubFilter) }}</h6>

            <div
              class="option"
              *ngFor="let option of getSubFilterOptions(activeSubFilter)"
              [class.selected]="isSelectedFilterOption(activeSubFilter, option)"
              (click)="toggleFilterOption(activeSubFilter, option)"
            >
              {{ activeSubFilter === "type" ? getQuestionTypeLabel(option) : option }}
            </div>

            <div class="sub-filter-actions mt-2">
              <button class="btn btn-link" (click)="resetFilter(activeSubFilter)">
                Reset
              </button>
              <button class="btn btn-primary btn-sm" (click)="applyFilters()">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>

      <input
        inputmode="search"
        role="searchbox"
        type="search"
        name="search"
        id="search-questionnaire"
        class="search-box"
        placeholder="Search..."
        [(ngModel)]="searchQuery"
        (input)="onSearch(searchQuery)"
        aria-label="Search questions"
      />

      <button
        type="button"
        class="export-button"
        (click)="exportToExcel()"
        [disabled]="isExporting"
      >
        @if (isExporting) {
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Exporting...
        } @else {
          Export to Excel
        }
      </button>
    </div>
    <div class="table-container">
      <div class="horizontal-scroll-wrapper">
        <table class="question-table">
          <thead>
            <tr>
              <th>Section</th>
              <th>Type</th>
              <th>Question</th>
              <th>Response Options</th>
            </tr>
          </thead>
          <tbody>
            @for (question of paginatedQuestions; track question) {
              <tr>
                <td>{{ question.sectionName }}</td>
                <td>{{ getQuestionTypeLabel(question.questionType) }}</td>
                <td>{{ question.questionText }}</td>
                <td>{{ question.responseOptions }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination-controls-wrapper" *ngIf="totalQuestions > 0">
      <div class="pagination-controls-row">
        <div class="pagination-stack">
          <div class="pagination-controls">
            <button
              class="pagination-button pagination-nav"
              (click)="onPageChange(currentPage - 1)"
              [disabled]="currentPage === 1"
            >
              <i class="bi bi-chevron-left"></i>
              Back
            </button>
            <ng-container *ngIf="totalPages > 1">
              <ng-container *ngFor="let item of paginationItems">
                <button
                  *ngIf="item !== 'ellipsis'; else paginationEllipsis"
                  class="pagination-button pagination-page"
                  (click)="onPageChange(+item)"
                  [class.active]="currentPage === item"
                >
                  {{ item }}
                </button>
                <ng-template #paginationEllipsis>
                  <span class="pagination-ellipsis">...</span>
                </ng-template>
              </ng-container>
            </ng-container>
            <button
              class="pagination-button pagination-nav"
              (click)="onPageChange(currentPage + 1)"
              [disabled]="currentPage === totalPages"
            >
              Next
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
          <div class="pagination-summary">
            {{ pageRangeStart }}-{{ pageRangeEnd }} of {{ totalQuestions }}
          </div>
        </div>

        <div class="page-size-controls">
          <label for="initial-questionnaire-page-size">Result per page</label>
          <select
            id="initial-questionnaire-page-size"
            class="form-select form-select-sm"
            [(ngModel)]="pageSize"
            (ngModelChange)="onPageSizeChange($event)"
          >
            <option *ngFor="let option of pageSizeOptions" [ngValue]="option">
              {{ option === 0 ? "All" : option }}
            </option>
          </select>
        </div>
      </div>
    </div>
  }
</div>
